import { render, staticRenderFns } from "./MissionCoreValues.vue?vue&type=template&id=abaa233a&"
import script from "./MissionCoreValues.vue?vue&type=script&lang=js&"
export * from "./MissionCoreValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports